let currentRandom: (() => number) | undefined

function mulberry32(seed: number): () => number {
	let state = seed >>> 0
	return () => {
		state = (state + 0x6D2B79F5) >>> 0
		let t = Math.imul(state ^ (state >>> 15), 1 | state)
		t ^= t + Math.imul(t ^ (t >>> 7), 61 | t)
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
}

export function random(): number {
	return currentRandom ? currentRandom() : Math.random()
}

export function normalizeSeed(seed: number): number {
	if (!Number.isFinite(seed)) {
		throw new Error(`Invalid seed: ${seed}`)
	}
	return (Math.trunc(seed) >>> 0)
}

export function hashString(value: string): number {
	let hash = 2166136261
	for (let i = 0; i < value.length; i++) {
		hash ^= value.charCodeAt(i)
		hash = Math.imul(hash, 16777619)
	}
	return hash >>> 0
}

export function deriveSeed(baseSeed: number, salt: string): number {
	return (normalizeSeed(baseSeed) ^ hashString(salt)) >>> 0
}

export function withRandomSeed<T>(seed: number | undefined, fn: () => T): T {
	if (seed === undefined) {
		return fn()
	}

	const previous = currentRandom
	currentRandom = mulberry32(normalizeSeed(seed))
	try {
		return fn()
	} finally {
		currentRandom = previous
	}
}
